import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Alert, Logout } from '../icons';
import OnboardContent from '../onboarding/OnboardContent';

import { useLocation } from 'react-router-dom';
import { useAuthenticationProvider } from '../../authentication/authProvider';
import { STATUS_CODE } from '../../constants/constants';
import ConfirmModal from '../confirmationmodal/confirmationModal';
import { Button } from '../Ant';
import { Flex } from 'antd';
import { usePage } from '../../context/PageContext';
import { ErroPageWrapper } from './error.styled';
import { useNavigationStack } from '../../context/NavigationStackContext';

const ErrorPage = ({
  reset,
  isException = false,
}: {
  isException?: boolean;
  reset?: () => void;
}) => {
  const location = useLocation();
  const { setTitle } = usePage();
  const status = location.state?.status ?? STATUS_CODE.SOME_THING_WRONG;
  const { t } = useTranslation();
  const { goBack } = useNavigationStack();
  const { logout } = useAuthenticationProvider();
  const [isLogoutModalVisible, setIsLogoutModalVisible] = useState<boolean>(false);

  useEffect(() => {
    setTitle(t('common:error'));
  }, []);

  const handleRetry = () => {
    reset?.();
    goBack();
  };
  const errorMessages: Record<number, { title: string; subtitle: string }> = {
    [STATUS_CODE.SOME_THING_WRONG]: {
      title: t('common:somethingWentWrong'),
      subtitle: t('common:unexpectedServerError'),
    },
    [STATUS_CODE.BAD_GATEWAY]: {
      title: t('common:serviceConnectionIssue'),
      subtitle: t('common:troubleConnectingService'),
    },
    [STATUS_CODE.SERVICE_UNAVAILABLE]: {
      title: t('common:serviceTemporarilyUnavailable'),
      subtitle: t('common:serviceUnderMaintenance'),
    },
    [STATUS_CODE.GATEWAY_TIMEOUT]: {
      title: t('common:requestTimedOut'),
      subtitle: t('common:serverTooLongToRespond'),
    },
    [STATUS_CODE.TOO_MANY_REQUESTS]: {
      title: t('common:tooManyRequests'),
      subtitle: t('common:tooManyRequestsWait'),
    },
  };

  const { title, subtitle } = errorMessages[status] || {
    title: t('common:somethingWentWrong'),
    subtitle: t('common:unexpectedServerError'),
  };

  const handleLogout = () => {
    logout();
    setIsLogoutModalVisible(false);
  };
  const renderErrorContent = () => (
    <div className="d-flex justify-center flex-col items-center h-full  pb-gutter">
      <OnboardContent icon={<Alert />} title={title} subtitle={subtitle} />
      <Flex className="w-full" align="center" gap={5}>
        <Button
          size="large"
          block
          className="logout-btn"
          icon={<Logout />}
          data-testid="logout-button"
          maxwidth="120px"
          onClick={() => setIsLogoutModalVisible(true)}
        >
          {t('common:logout')}
        </Button>
        <Button data-testid="retry-button" type="primary" size="large" block onClick={handleRetry}>
          {t('common:retry')}
        </Button>
      </Flex>

      <ConfirmModal
        visible={isLogoutModalVisible}
        onClose={() => setIsLogoutModalVisible(false)}
        icon={<Logout />}
        title={t('common:logOutQuestion')}
        subtitle={t('common:logOutMessage')}
        cancelText={t('common:cancel')}
        confirmText={t('common:logOutBtnText')}
        onConfirm={handleLogout}
      />
    </div>
  );

  return isException ? (
    <ErroPageWrapper>
      <header className="main-header">{t('common:error')}</header>
      {renderErrorContent()}
    </ErroPageWrapper>
  ) : (
    renderErrorContent()
  );
};

export default ErrorPage;
